const routerLinks = {
  homePage: '/',

  ////////////////////////////
  ////////////////////////////////
  notFound: '/not-found'
};

export default routerLinks;
